import React from 'react';



function BetBuilderMatchPreview(props) {
	const match = props.betBuilderMatch;
	
	return <div onClick={props.onClick} className={"betBuilderMatchPreview " + (props.selected? 'selected' :'')}>
		<div className={"timestamp"}> {match.date} {match.time}</div>
		<div className={"matchname"}> {match.desc} </div>
	</div>;
}

export default BetBuilderMatchPreview;
